import { SideCard } from '@components/side-card'
import * as React from 'react'

export const SubscriptionCardSideCard = (): JSX.Element => (
  <SideCard
    className="d-lg-block d-none"
    image={<img src={require('@assets/images/subscription-label.jpg')} alt="Subscription voucher" />}
  />
)
